export default "__VITE_ASSET__75f3b83c__"